module.exports = __webpack_public_path__ + "static/media/dog-leashed.4c0d724a.svg";